import * as React from 'react';
import { SVGProps } from 'react';

const SvgOutperform = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <rect width={32} height={32} rx={16} fill="#A0D4D3" />
    <path
      d="M11.625 20.122c2.06 0 3.34-1.401 3.34-3.642v-.01c0-2.237-1.284-3.638-3.34-3.638-2.05 0-3.345 1.401-3.345 3.638v.01c0 2.24 1.284 3.642 3.345 3.642Zm0-1.094c-1.26 0-2.06-.981-2.06-2.548v-.01c0-1.568.805-2.544 2.06-2.544 1.26 0 2.06.981 2.06 2.544v.01c0 1.552-.786 2.548-2.06 2.548Zm6.411-6.074h-1.103l-1.846 8.755h1.099l1.85-8.755Zm.65 7.046h1.26v-2.33H21.4c1.426 0 2.398-.946 2.398-2.353v-.01c0-1.41-.972-2.353-2.398-2.353h-2.714V20Zm2.402-6.016c.903 0 1.43.484 1.43 1.329v.01c0 .844-.527 1.332-1.43 1.332h-1.143v-2.67h1.143Z"
      fill="#174174"
    />
  </svg>
);

export default SvgOutperform;
